/* @sravni/react-header version 0.2.43 */
import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { Layout } from '@sravni/react-design-system/lib/Layout';
import modules_19d504b8 from '../styles/DropdownMenu.module.less.js';

/**
 * @description Desktop dropdown menu component.
 *
 * @component
 * @example
 * ```jsx
 * <DropdownMenu />
 * ```
 */
var DropdownMenu = React.forwardRef(function (props, ref) {
    var wide = props.wide, fullscreen = props.fullscreen, className = props.className, children = props.children, restProps = __rest(props, ["wide", "fullscreen", "className", "children"]);
    var cx = useStyles(modules_19d504b8);
    return (React.createElement("div", __assign({ ref: ref, className: cx(className, 'container', { 'container--fullscreen': fullscreen }) }, restProps),
        React.createElement("div", { className: cx('menu') },
            React.createElement(Layout, { className: cx('layout') },
                React.createElement("div", { className: cx('wrapper', { 'wrapper--wide': wide }) }, children)))));
});
DropdownMenu.defaultProps = {
    wide: false
};

export { DropdownMenu as default };
//# sourceMappingURL=DropdownMenu.js.map
